<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <template v-if="warning.show">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Atenção!</h4>
                        <p class="mb-0">{{ warning.message }}</p>
                    </div>
                </template>
                <template v-else>
                    <div :class="platform == 'desktop' ? 'card-deck' : 'card border-0 bg-transparent'">
                        <div class="card bg-light border-0 mb-3">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <i class="fas fa-piggy-bank mr-2"></i>Faturamento
                                    </div>
                                    <div class="col-auto pr-0">
                                        <i class="far fa-money-check-edit-alt" :class="paymentActive ? 'text-success' : 'text-danger'" role="button" @click="togglePayment"></i>
                                    </div>
                                    <div class="col-auto">
                                        <template v-if="!show">
                                            <i class="fas fa-eye" role="button" @click="show = true"></i>
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-eye-slash" role="button" @click="show = false"></i>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <h1 class="card-title text-center">
                                    <template v-if="!show">
                                        <i class="fas fa-eye-slash"></i>
                                    </template>
                                    <template v-else>
                                        <span>{{revenues | formatCoin}}</span>
                                    </template>
                                </h1>
                            </div>
                        </div><!-- /card -->
                        <div class="card bg-light border-0 mb-3 ml-0 mr-0">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <i class="fas fa-users mr-2"></i>Total de clientes
                                    </div>
                                    <div class="col-auto pr-0" role="button" @click="filterRelatorio">
                                        <i class="fas fa-funnel-dollar"></i>
                                    </div>
                                    <div class="col-auto" role="button" @click="createRelatorio">
                                        <i class="fas fa-file-pdf"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <h1 class="card-title text-center">
                                    <span>{{ clients.length }}</span>
                                </h1>
                            </div>
                        </div><!-- /card -->
                        <div class="card bg-light border-0 mb-3">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col">
                                        <i class="fas fa-user-check mr-2"></i>
                                        <template v-if="total_outstanding.clients">
                                            Clientes pendentes <span class="badge badge-danger">{{ total_outstanding.clients }}</span>
                                        </template>
                                        <template v-else>Clientes ativos</template>
                                    </div>
                                    <div class="col-auto" role="button">
                                        <template v-if="!status_da_cobranca">
                                            <i class="fas fa-exchange-alt" @click="status_da_cobranca = 'Atrasado'"></i>
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-exchange-alt" @click="status_da_cobranca = ''"></i>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <h1 class="card-title text-center">
                                    <template v-if="total_outstanding.clients">
                                        <span>R$ {{ total_outstanding.amount | formatCoin }}</span>
                                    </template>
                                    <template v-else>
                                        <span>{{ active_clients }}</span>
                                    </template>
                                </h1>
                            </div>
                        </div><!-- /card -->
                    </div><!-- /card-deck -->
                    <div class="w-100" v-show="!loading">
                        <div class="btn-group w-100 mb-3" role="group" aria-label="Button group with nested dropdown">
                            <button type="button" class="btn btn-secondary" @click.prevent="active = 'sim'" :class="{'active': active == 'sim'}" :disabled="active == 'sim'">
                                <i class="fas fa-user-check mr-2"></i>Ativo
                            </button>
                            <button type="button" class="btn btn-secondary" @click.prevent="active = 'nao'" :class="{'active': active == 'nao'}" :disabled="active == 'nao'">
                                <i class="fas fa-user-lock mr-2"></i>Bloqueado
                            </button>
                        </div><!-- /btn-group -->
                        <div class="w-100 mb-3">
                            <input v-model="search" type="text" class="form-control" placeholder="Buscar cliente..." autocomplete="off" spellcheck="false">
                        </div>
                    </div>
                    <template v-if="filteredListClients.length == 0 && !loading">
                        <div class="alert alert-warning" role="alert">
                            <h4 class="alert-heading">Atenção!</h4>
                            <p class="mb-0">Nenhum cliente encontrado!</p>
                        </div>
                    </template>
                    <template v-else>
                        <div class="card bg-light border-0 mb-3" v-for="(item, index) in filteredListClients" :key="index">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col text-truncate mt-1">{{ item.nome }}</div>
                                    <div class="col-auto pr-0" v-if="platform == 'mobile'">
                                        <button class="btn btn-sm btn-block btn-success" @click="share(item)">
                                            <i class="fab fa-whatsapp"></i>
                                        </button>
                                    </div>
                                    <div class="col-auto pr-0" v-if="platform == 'mobile'">
                                        <button class="btn btn-sm btn-block btn-primary" @click="shareData(item)">
                                            <i class="fas fa-share-alt"></i>
                                        </button>
                                    </div>
                                    <div class="col-auto pr-0">
                                        <button class="btn btn-sm btn-block btn-danger" @click="deleteClient(item)">
                                            <template v-if="platform == 'desktop'">
                                                <i class="fas fa-user-times mr-2"></i>Excluir
                                            </template>
                                            <template v-else>
                                                <i class="fas fa-user-times"></i>
                                            </template>
                                        </button>                                        
                                    </div>
                                    <div class="col-auto">
                                        <button class="btn btn-sm btn-block btn-secondary" @click="editClient(item)">
                                            <template v-if="platform == 'desktop'">
                                                <i class="fas fa-user-edit mr-2"></i>Editar
                                            </template>
                                            <template v-else>
                                                <i class="fas fa-user-edit"></i>
                                            </template>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col text-truncate">Ativo</div>
                                    <div class="col text-truncate">{{item.ativo  == 'sim' ? 'Sim' : 'Não'}}</div>
                                </div>
                                <div class="row border-top mt-2 pt-2">
                                    <div class="col text-truncate">Gateway</div>
                                    <div class="col text-truncate text-info text-uppercase">{{item.gateway}}</div>
                                </div>
                                <div class="row border-top mt-2 pt-2">
                                    <div class="col text-truncate">Pagamento</div>
                                    <div class="col text-truncate" :class="item.status_da_cobranca == 'Atrasado' ? 'text-warning' : 'text-success'">{{item.status_da_cobranca}}</div>
                                </div>
                                <div class="row border-top mt-2 pt-2">
                                    <div class="col text-truncate">Mensalidade</div>
                                    <div class="col text-truncate">{{item.mensalidade | formatCoin}}</div>
                                </div>
                                <div class="row border-top mt-2 pt-2">
                                    <div class="col text-truncate">Data de início</div>
                                    <div class="col text-truncate">{{item.data_de_inicio | formatDate}}</div>
                                </div>
                                <div class="row border-top mt-2 pt-2">
                                    <div class="col text-truncate">Data da cobrança</div>
                                    <div class="col text-truncate">{{item.data_da_cobranca | formatDate}}</div>
                                </div>
                                <div class="row border-top mt-2 pt-2">
                                    <div class="col text-truncate">Site da empresa</div>
                                    <div class="col text-truncate text-danger">{{item.site.replace('www.','')}}</div>
                                </div>
                                <div class="row border-top mt-2 pt-2">
                                    <div class="col text-truncate">Qtd. de esportes</div>
                                    <div class="col text-truncate">{{item.esportes.length == 1 ? '1 esporte' : `${item.esportes.length} esportes`}}</div>
                                </div>
                                <div class="row border-top mt-2 pt-2">
                                    <div class="col text-truncate">
                                        <button class="btn btn-sm btn-block btn-warning" @click="showList(item.esportes)">
                                            <i class="fas fa-eye mr-2"></i>Lista de esportes
                                        </button>
                                    </div>
                                    <div class="w-100 mt-3" v-if="platform == 'mobile'"></div>
                                    <div class="col text-truncate">
                                        <button class="btn btn-sm btn-block btn-success" @click="confirmPay(item)">
                                            <i class="fas fa-handshake mr-2"></i>Pagamento manual
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div><!-- /card -->
                    </template>
                </template>
            </div>
        </div>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import moment from 'moment-timezone'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default {
    data() {
        return {
            search: '',
            show: false,
            clients: [],
            active: 'sim',
            status_da_cobranca: '',
            loading: false,
            warning: {
                show: false,
                message: ''
            },
            revenues: 0,
            active_clients: 0,
            max_pix: 6000,
            paymentDay: 'nao',
            paymentActive: true,
            paymentGateway: 'bspay',
            total_outstanding: {
                clients: 0,
                amount: 0
            },
            today: moment().tz('America/Recife').format('YYYY-MM-DD'),
            platform: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    methods: {
        listClients() {

            const self = this;

            self.clients = [];
            self.loading = true;
            self.warning.show = false;

            api.get('list-clients').then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.max_pix = response.data.max_pix;
                        self.paymentDay = response.data.paymentDay;
                        self.paymentActive = response.data.paymentActive;
                        self.paymentGateway = response.data.paymentGateway;
                        self.clients = response.data.clients.sort((a, b) => {
                            return a.data_de_inicio > b.data_de_inicio ? 1 : a.data_de_inicio < b.data_de_inicio ? -1 : 0;
                        }).map((item) => {
                            return {
                                _id: item._id,
                                pin: item.pin,
                                api: item.api,
                                nome: item.nome,
                                site: item.site,
                                gateway: item.gateway,
                                app_nome: item.app_nome,
                                esportes: item.esportes,
                                telefone: item.telefone,
                                mensalidade: item.mensalidade,
                                data_de_inicio: item.data_de_inicio,
                                data_da_cobranca: item.data_da_cobranca,
                                status_da_cobranca: (self.today > item.data_da_cobranca) ? 'Atrasado' : 'Em dia',
                                ativo: item.ativo == 1 ? 'sim' : 'nao',
                                cobrar_multa_por_atraso: item.cobrar_multa_por_atraso,
                                validar_resultado_primeiro_tempo: item.validar_resultado_primeiro_tempo,
                                cliente_nome: item.cliente_nome || '---',
                                cliente_documento: item.cliente_documento || '---',
                                cliente_address: item.cliente_address || '---',
                                cliente_cep: item.cliente_cep || '---',
                                cliente_city: item.cliente_city || '---',
                                cliente_state: item.cliente_state || '---',
                                idPagamento: item.idPagamento || '---'
                            }
                        });
                    break;
                    case 'nothing_found':
                        self.warning.show = true;
                        self.warning.message = 'Nenhum cliente encontrado!';
                    break;
                    default:
                        self.warning.show = true;
                        self.warning.message = response.data.message;
                    break;
                }
            }).catch((error) => {
                try {
                    self.warning.show = true;
                    self.warning.message = self.network_erros[error.status]['message'];
                } catch(e) {
                    self.warning.show = true;
                    self.warning.message = self.network_erros[408]['message'];
                }
            }).finally(() => {
                self.loading = false;
            });
        },
        deleteClient(client) {

            const self = this; 

            Swal.fire({
                title: 'Excluir cliente',
                html: `Você deseja mesmo excluir o cliente <b class="text-uppercase">${client.nome}</b> ?`,
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim'
            }).then((result) => {

                if (result.value) {

                    self.loading = true;

                    api.delete(`delete-client/${client._id}`).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                Swal.fire(
                                    'Parabéns!',
                                    'O cliente foi excluído com sucesso',
                                    'success'
                                );
                            break;
                            default:
                                Swal.fire(
                                    'Atenção',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            }); 
        },
        async editClient(client) {

            const self = this;

            const { value: formValues } = await Swal.fire({
                title: 'Editar cliente',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Salvar',
                html: `
                    <div style="width:100%;height:auto;max-height:400px;overflow-y:scroll;">
                        <label class="d-block text-left mb-0">ID</label>
                        <input id="swal-input0" class="swal2-input" type="text" value="${client._id}" readonly autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">PIN</label>
                        <input id="swal-input00" class="swal2-input" type="text" value="${client.pin}" readonly autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Ativo</label>
                        <select id="swal-input6" class="swal2-input w-100">
                            <option value="1" ${client.ativo == 'sim' ? 'selected' : ''}>Sim</option>
                            <option value="2" ${client.ativo == 'nao' ? 'selected' : ''}>Não</option>
                        </select>

                        <label class="d-block text-left mb-0">Gateway</label>
                        <select id="swal-input18" class="swal2-input w-100">
                            <option value="brpix" ${client.gateway == 'brpix' ? 'selected' : ''}>BRPix</option>
                            <option value="bspay" ${client.gateway == 'bspay' ? 'selected' : ''}>BSPay</option>
                            <option value="suitpay" ${client.gateway == 'suitpay' ? 'selected' : ''}>SuitPay</option>
                            <option value="veopag" ${client.gateway == 'veopag' ? 'selected' : ''}>VeoPag</option>
                        </select>

                        <label class="d-block text-left mb-0">Nome</label>
                        <input id="swal-input1" class="swal2-input" type="text" value="${client.nome}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Mensalidade</label>
                        <input id="swal-input2" class="swal2-input" type="text" value="${client.mensalidade}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Telefone</label>
                        <input id="swal-input7" class="swal2-input" type="text" value="${client.telefone}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Data da cobrança</label>
                        <input id="swal-input3" class="swal2-input" type="date" value="${client.data_da_cobranca}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Site da empresa</label>
                        <input id="swal-input4" class="swal2-input" type="text" value="${client.site}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">API da empresa</label>
                        <input id="swal-input8" class="swal2-input" type="text" value="${client.api}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Aplicativo</label>
                        <input id="swal-input9" class="swal2-input" type="text" value="${client.app_nome}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Lista de esportes</label>
                        <input id="swal-input5" class="swal2-input" type="text" value="${client.esportes.join('/')}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Cobrar multa por atraso</label>
                        <select id="swal-input10" class="swal2-input w-100">
                            <option value="sim" ${client.cobrar_multa_por_atraso == 'sim' ? 'selected' : ''}>Sim</option>
                            <option value="nao" ${client.cobrar_multa_por_atraso == 'nao' ? 'selected' : ''}>Não</option>
                        </select>

                        <label class="d-block text-left mb-0">Validar resultado do primeiro tempo</label>
                        <select id="swal-input11" class="swal2-input w-100">
                            <option value="sim" ${client.validar_resultado_primeiro_tempo == 'sim' ? 'selected' : ''}>Sim</option>
                            <option value="nao" ${client.validar_resultado_primeiro_tempo == 'nao' ? 'selected' : ''}>Não</option>
                        </select>

                        <label class="d-block text-left mb-0">Cliente responsável</label>
                        <input id="swal-input12" class="swal2-input" type="text" value="${client.cliente_nome}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">CPF</label>
                        <input id="swal-input13" class="swal2-input" type="text" value="${client.cliente_documento}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Endereço</label>
                        <input id="swal-input14" class="swal2-input" type="text" value="${client.cliente_address}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">CEP</label>
                        <input id="swal-input15" class="swal2-input" type="text" value="${client.cliente_cep}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Cidade</label>
                        <input id="swal-input16" class="swal2-input" type="text" value="${client.cliente_city}" autocomplete="off" spellcheck="false">

                        <label class="d-block text-left mb-0">Estado</label>
                        <input id="swal-input17" class="swal2-input" type="text" value="${client.cliente_state}" autocomplete="off" spellcheck="false">    
                    </div>
                `,
                focusConfirm: false,
                preConfirm: () => {
                    return {
                        api: document.getElementById('swal-input8').value,
                        site: document.getElementById('swal-input4').value,
                        nome: document.getElementById('swal-input1').value,
                        ativo: document.getElementById('swal-input6').value,
                        gateway: document.getElementById('swal-input18').value,
                        app_nome: document.getElementById('swal-input9').value,
                        telefone: document.getElementById('swal-input7').value,
                        mensalidade: document.getElementById('swal-input2').value,
                        data_da_cobranca: document.getElementById('swal-input3').value,
                        esportes: self.setSports(document.getElementById('swal-input5').value),
                        cobrar_multa_por_atraso: document.getElementById('swal-input10').value,
                        validar_resultado_primeiro_tempo: document.getElementById('swal-input11').value,
                        cliente_nome: document.getElementById('swal-input12').value,
                        cliente_documento: document.getElementById('swal-input13').value,
                        cliente_address: document.getElementById('swal-input14').value,
                        cliente_cep: document.getElementById('swal-input15').value,
                        cliente_city: document.getElementById('swal-input16').value,
                        cliente_state: document.getElementById('swal-input17').value
                    }
                },
                onOpen: () => {

                    document.getElementById("swal-input1").addEventListener("input", (e) => {
                        return e.target.value = e.target.value.replace(/[^a-zà-ú0-9\s]+/gi, '');
                    });

                    document.getElementById("swal-input2").addEventListener("input", (e) => {
                        return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    });

                    document.getElementById("swal-input4").addEventListener("input", (e) => {
                        return e.target.value = e.target.value.replace(/[^a-z0-9.-]/g, '');
                    });

                    document.getElementById("swal-input5").addEventListener("input", (e) => {
                        return e.target.value = e.target.value.replace(/[^a-zà-ú-/\s]+/gi, '');
                    });

                    document.getElementById("swal-input7").addEventListener("input", (e) => {
                        return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    });

                    document.getElementById("swal-input9").addEventListener("input", (e) => {
                        return e.target.value = e.target.value.replace(/[^a-zA-Z0-9.-]/g, '');
                    });

                    document.getElementById("swal-input13").addEventListener("input", (e) => {
                        return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    });

                    document.getElementById("swal-input15").addEventListener("input", (e) => {
                        return e.target.value = e.target.value.replace(/[^0-9-]/g, '');
                    });
                }
            });

            if (formValues) {

                if (self.trim(formValues.nome) == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o nome do cliente!',
                        'warning'
                    )
                } else if (self.trim(formValues.mensalidade) == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o valor da mensalidade!',
                        'warning'
                    )
                } else if (formValues.data_da_cobranca == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe a data de cobrança da mensalidade!',
                        'warning'
                    )
                } else if (formValues.telefone == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o número de telefone do cliente!',
                        'warning'
                    )
                } else if (self.trim(formValues.site) == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o site da empresa!',
                        'warning'
                    )
                } else if (self.trim(formValues.api) == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe a API da empresa!',
                        'warning'
                    )
                } else if (self.trim(formValues.app_nome) == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o nome do aplicativo!',
                        'warning'
                    )
                } else if (formValues.esportes.includes('')) {
                    Swal.fire(
                        'Atenção!',
                        'Informe pelo menos um esporte!',
                        'warning'
                    )
                } 
                else 
                {
                    Swal.fire({
                        title: 'Salvar alterações',
                        html: `Você deseja mesmo salvar as alterações do <b>${formValues.nome}</b> ?`,
                        showCancelButton: true,
                        confirmButtonColor: '#28a745',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancelar',
                        confirmButtonText: 'Sim'
                    }).then((result) => {

                        if (result.value) {

                            self.loading = true;

                            api.post('edit-client', {
                                id: client._id,
                                form: formValues
                            }).then((response) => {
                                switch(response.data.result) {
                                    case 'success':
                                        Swal.fire(
                                            'Parabéns!',
                                            'As alterações foram salvas com sucesso!',
                                            'success'
                                        );
                                    break;
                                    default:
                                        Swal.fire(
                                            'Atenção',
                                            response.data.message,
                                            'warning'
                                        );
                                    break;
                                }
                            }).catch((error) => {
                                try {
                                    Swal.fire(
                                        'Falha',
                                        self.network_erros[error.status]['message'],
                                        'warning'
                                    );
                                } catch(e) {
                                    Swal.fire(
                                        'Falha',
                                        self.network_erros[408]['message'],
                                        'warning'
                                    );
                                }
                            }).finally(() => {
                                self.loading = false;
                            });
                        }
                    });
                }
            }
        },
        setSports(values) {

            let sports = [];
            let list_sports = values.split('/');

            for (let i = 0; i < list_sports.length; i++) {
                sports.push(list_sports[i]);
            }

            return sports;
        },
        showList(sports) {

            let html = '';

            sports.forEach((sport, index) => {

                if (index == 0) {
                    html += '<div class="row">';
                    html += '<div class="col text-truncate">';
                    html += sport;
                    html += '</div>';
                    html += '</div>';
                } else {
                    html += '<div class="row border-top mt-2 pt-2">';
                    html += '<div class="col text-truncate">';
                    html += sport;
                    html += '</div>';
                    html += '</div>';
                }
            });

            Swal.fire(
                'Lista de esportes',
                html,
            )
        },
        trim(value) {
            return value.toString().trim();
        },
        removeAccents(str) {
            
            let string = str;
            let map = {a : /[\xE0-\xE6]/g, A : /[\xC0-\xC6]/g, e : /[\xE8-\xEB]/g, E : /[\xC8-\xCB]/g, i : /[\xEC-\xEF]/g, I : /[\xCC-\xCF]/g, o : /[\xF2-\xF6]/g, O : /[\xD2-\xD6]/g, u : /[\xF9-\xFC]/g, U : /[\xD9-\xDC]/g, c : /\xE7/g, C : /\xC7/g, n : /\xF1/g, N : /\xD1/g};

            for (let key in map) {
                 let rex = map[key];
                 string = string.replace(rex, key);
            }

            return string;
        },
        share(item) {
            window.location.href = `whatsapp://send?text=${encodeURIComponent(`Olá, *${item.nome}*.\n\nPara efetuar o *pagamento* acesse o link:\n\nhttps://payment.betsnow.net?pin=${item.pin}\n\nCaso seja necessário, informe o PIN:\n\n*${item.pin}*\n\nPor questões de segurança, o *LINK* irá expirar assim que o pagamento for efetuado.`)}`;
        },
        shareData(item) {
            window.location.href = `whatsapp://send?text=${encodeURIComponent(`*Dados do cliente:*\n\nValor: *R$ ${item.mensalidade}*\nNome: *${item.cliente_nome}*\nCPF: *${item.cliente_documento}*\n\nEstado: *${item.cliente_state}*\nCidade: *${item.cliente_city}*\nEndereço: *${item.cliente_address}*\nCEP: *${item.cliente_cep}*`)}`;
        },
        async togglePayment() {

            const self = this;

            if (self.loading) return;

            const { value: formValues } = await Swal.fire({
                title: 'Pagamento',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Salvar',
                html: `
                    <label class="d-block text-left mb-0">Ativo</label>
                    <select id="swal-input1" class="swal2-input w-100">
                        <option value="s" ${self.paymentActive ? 'selected' : ''}>Sim</option>
                        <option value="n" ${self.paymentActive ? '' : 'selected'}>Não</option>
                    </select>

                    <label class="d-block text-left mb-0">Limite do PIX</label>
                    <input id="swal-input2" class="swal2-input" type="text" value="${self.max_pix}" autocomplete="off" spellcheck="false">

                    <label class="d-block text-left mb-0">Gateway padrão</label>
                    <select id="swal-input3" class="swal2-input w-100">
                        <option value="brpix" ${self.paymentGateway == 'brpix' ? 'selected' : ''}>BRPix</option>
                        <option value="bspay" ${self.paymentGateway == 'bspay' ? 'selected' : ''}>BSPay</option>
                        <option value="suitpay" ${self.paymentGateway == 'suitpay' ? 'selected' : ''}>SuitPay</option>
                        <option value="veopag" ${self.paymentGateway == 'veopag' ? 'selected' : ''}>VeoPag</option>
                        <option value="auto" ${self.paymentGateway == 'auto' ? 'selected' : ''}>Automático</option>
                    </select>

                    <label class="d-block text-left mb-0">Permitir mais de um pagamento por dia</label>
                    <select id="swal-input4" class="swal2-input w-100">
                        <option value="sim" ${self.paymentDay == 'sim' ? 'selected' : ''}>Sim</option>
                        <option value="nao" ${self.paymentDay == 'nao' ? 'selected' : ''}>Não</option>
                    </select>
                `,
                focusConfirm: false,
                preConfirm: () => {
                    return {
                        ativo: document.getElementById('swal-input1').value,
                        max_pix: document.getElementById('swal-input2').value,
                        gateway: document.getElementById('swal-input3').value,
                        paymentDay: document.getElementById('swal-input4').value
                    }
                },
                onOpen: () => {
                    document.getElementById("swal-input2").addEventListener("input", (e) => {
                        return e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    });
                }
            });

            if (formValues) {

                self.loading = true;

                api.post('edit-payment', {
                    active: formValues.ativo,
                    max_pix: formValues.max_pix,
                    gateway: formValues.gateway,
                    paymentDay: formValues.paymentDay
                }).then((response) => {
                    switch(response.data.result) {
                        case 'success':
                            self.max_pix = response.data.max_pix;
                            self.paymentActive = response.data.active;
                            self.paymentGateway = response.data.gateway;
                            self.paymentDay = response.data.paymentDay;
                            Swal.fire(
                                'Parabéns!',
                                'As alterações foram salvas com sucesso!',
                                'success'
                            );
                        break;
                        default:
                            Swal.fire(
                                'Atenção',
                                response.data.message,
                                'warning'
                            );
                        break;
                    }
                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            self.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            self.network_erros[408]['message'],
                            'warning'
                        );
                    }
                }).finally(() => {
                    self.loading = false;
                });
            }
        },
        confirmPay(item) {

            const self = this;

            Swal.fire({
                title: 'Confirmar pagamento',
                html: `Você deseja mesmo confirmar o pagamento do cliente <strong>${item.nome}</strong> ?`,
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Não',
                confirmButtonText: 'Sim'
            }).then((result) => {

                if (result.value) {

                    self.loading = true;

                    api.put(`confirm-payment/${item._id}`).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                Swal.fire(
                                    'Parabéns!',
                                    'O pagamento foi confirmado com sucesso, já é possível ver no relatório!',
                                    'success'
                                );
                            break;
                            default:
                                Swal.fire(
                                    'Atenção',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            });
        },
        diffTwoDates(nDate) {
            var startDate = new Date(); 
            var endDate = new Date(new Date(nDate));
            return Math.abs((endDate.getFullYear() - startDate.getFullYear())*12 + (endDate.getMonth() - startDate.getMonth()));
        },
        clientsOrder() {
            return this.clients.slice().sort((a, b) => {
                return this.removeAccents(a.cliente_nome).localeCompare(this.removeAccents(b.cliente_nome));
            });
        },
        createRelatorio() {
            let html = '';
            let blacklist = ['5fb67a6d1a5c417c82fb2ea4'];

            const servicos = {
                "Futebol": "VPS",
                "Basquete": "+ Database",
                "Lutas": "+ Backup",
                "Voleibol": "+ Load balance",
                "Hoquei": "+ Suporte extra 24/7",
                "Tenis": "+ Anti-DDoS",
                "eSports": "+ Outros"
            };

            for (const item of this.clientsOrder()) {
                let list = '';

                if (item.ativo == 'sim' && !blacklist.includes(item._id)) {

                    html += `<tr>`;
                    html += `<td>${item._id}</td>`;
                    html += `<td>${item.idPagamento}</td>`;
                    html += `<td class="text-uppercase">${item.cliente_nome}</td>`;
                    html += `<td>${item.cliente_documento}</td>`;
                    html += `<td>${item.cliente_cep}</td>`;
                    html += `<td>${item.cliente_state}</td>`;
                    html += `<td>${item.cliente_city}</td>`;
                    html += `<td>${item.cliente_address}</td>`;
                    html += `<td class="text-uppercase">${item.ativo}</td>`;
                    html += `<td class="text-uppercase">${item.status_da_cobranca}</td>`;
                    html += `<td>R$ ${item.mensalidade}</td>`;
                    
                    for (let key in item.esportes) {
                        let sport = item.esportes[key];

                        if (sport) {
                            list += ' ' + servicos[this.removeAccents(sport)];
                        }
                    }

                    html += `<td>${list}</td>`;
                    html += `<td>${item.data_da_cobranca}</td>`;
                    html += `<td>${item.data_de_inicio}</td>`;
                    html += `</tr>`;
                }
            }

            const winHtml = `<!DOCTYPE html>
                <html>
                    <head>
                        <meta charset="utf-8"/>
                        <title>Window with Blob</title>
                        <style>
                            table, tbody {
                                max-width: 100%; 
                            }
                            table.blueTable {
                                border: 1px solid #1C6EA4;
                                background-color: #EEEEEE;
                                width: 100%;
                                text-align: left;
                                border-collapse: collapse;
                            }
                            table.blueTable td, table.blueTable th {
                                border: 1px solid #AAAAAA;
                                padding: 3px 2px;
                            }
                            table.blueTable tbody td {
                                font-size: 13px;
                            }
                            table.blueTable tr:nth-child(even) {
                                background: #D0E4F5;
                            }
                            table.blueTable thead {
                                background: #1C6EA4;
                                background: -moz-linear-gradient(top, #5592bb 0%, #327cad 66%, #1C6EA4 100%);
                                background: -webkit-linear-gradient(top, #5592bb 0%, #327cad 66%, #1C6EA4 100%);
                                background: linear-gradient(to bottom, #5592bb 0%, #327cad 66%, #1C6EA4 100%);
                                border-bottom: 2px solid #444444;
                            }
                            table.blueTable thead th {
                                font-size: 15px;
                                font-weight: bold;
                                color: #FFFFFF;
                                border-left: 2px solid #D0E4F5;
                            }
                            table.blueTable thead th:first-child {
                                border-left: none;
                            }

                            table.blueTable tfoot {
                                font-size: 14px;
                                font-weight: bold;
                                color: #FFFFFF;
                                background: #D0E4F5;
                                background: -moz-linear-gradient(top, #dcebf7 0%, #d4e6f6 66%, #D0E4F5 100%);
                                background: -webkit-linear-gradient(top, #dcebf7 0%, #d4e6f6 66%, #D0E4F5 100%);
                                background: linear-gradient(to bottom, #dcebf7 0%, #d4e6f6 66%, #D0E4F5 100%);
                                border-top: 2px solid #444444;
                            }
                            table.blueTable tfoot td {
                                font-size: 14px;
                            }
                            .text-uppercase {
                                text-transform: uppercase;
                            }
                        </style>
                    </head>
                    <body>
                       <table class="blueTable">
                            <thead>
                                <tr>
                                    <th>ID Cliente</th>
                                    <th>ID Pagamento</th>
                                    <th>Cliente</th>
                                    <th>CPF</th>
                                    <th>CEP</th>
                                    <th>Estado</th>
                                    <th>Cidade</th>
                                    <th>Endereço</th>
                                    <th>Ativo</th>
                                    <th>Status da cobrança</th>
                                    <th>Valor recorrente</th>
                                    <th>Serviços / Produtos oferecidos</th>
                                    <th>Data de pagamento</th>
                                    <th>Cliente desde</th>
                                </tr>    
                            </thead>
                            <tbody>${html}</tbody>
                        </table>
                    </body>
                </html>`;

            if (html) {
                const winUrl = URL.createObjectURL(
                    new Blob([winHtml], { type: "text/html" })
                );

                window.open(
                    winUrl,
                    "win",
                    `width=800,height=400,screenX=200,screenY=200`
                );
            }
        },
        async filterRelatorio() {

            const self = this;

            const { value: formValues } = await Swal.fire({
                title: 'Relatório financeiro',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Buscar',
                html: `
                    <label class="d-block text-left mb-0">Data inicial</label>
                    <input id="swal-input1" class="swal2-input" type="date" autocomplete="off" spellcheck="false">

                    <label class="d-block text-left mb-0">Data final</label>
                    <input id="swal-input2" class="swal2-input" type="date" autocomplete="off" spellcheck="false">
                `,
                focusConfirm: false,
                preConfirm: () => {
                    return {
                        data_in: document.getElementById('swal-input1').value,
                        data_fn: document.getElementById('swal-input2').value,
                    }
                }
            });

            if (formValues) {
                
                if (formValues.data_in == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe a data inicial!',
                        'warning'
                    )
                } else if (formValues.data_fn == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe a data final!',
                        'warning'
                    )
                } else {

                    self.loading = true;

                    api.post('financial-report', formValues).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                self.gerarRelatorioPDF(response.data.monthlyfees, formValues);
                            break;
                            default:
                                Swal.fire(
                                    'Atenção',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            }
        },
        gerarRelatorioPDF(relatorios, formValues) {

            try {
                const doc = new jsPDF({
                    orientation: "landscape",
                    unit: "px",
                    format: [800, window.innerHeight]
                });

                let total = 0;
                const logoBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA7CAMAAADy+wKBAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAblQTFRFAAAAM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzUtRSoeeh0fTR////7frtSdJJPM48heGFS9JLk+ST+P34W9ZbStJKbttuSdFJZtlmZNhked153PbcgeCBneed+f754fjhN803R9FH5/nnaNloiuKK9v32xfDF8vzyQM9AhuGGZ9ln0/TT1fXVNs02xfHFYthiP88/Os46fN58RdBFp+mn+/77meaZcdxxv++/+v76V9VXY9hjUdNRZdhlseyxheCF6fnppOikgN+AXtdeWNVYUdRROc45wfDB/f/9ctxyNc01t+239Pz0oeihQdBBVdRVjuOOve+95Pjk2fXZU9RTPs8+atpqzfPNg+CDZdll+f35SNFItOy0UNNQsOuwue25dd11guCC/P780vTSVNRUkuSSQtBCw/DDed55Qc9BcNtwneadqOmo9/337PrsNMw0bdptte21XdddvO68d913muaaj+OP2fbZl+WXu+67zfLNTtNOwe/BRNBEieGJquqqet56M8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzM8wzeHwUXAAAAJN0Uk5TAA8VESPI/9s9F+kzmMTkAggH////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////yfRTg4u3k6FPp5+dsQAAAiRJREFUeJxjZGBgYGRkIBUw/gURDCxkaAXZ94OBkZPxDxlagYD1KyPPL/K0MrB/ZuT7QaZeBk5GNnK1MnBRoJd7VO+o3lG9g0kvDyOw4GP8y/IeVZUQUPANAb2i0LKLnfEliiqJ7wxczxmkGBmf4NQr+4mBH1hqsjK+E2a8i6xKBWjvLQb1F5I3cOrVfCbNeBVI6zxmkLuM6T+8evUeKlwE0QaMPzjPCXEySJxlYDB+wSB5xgRo76/XMjc0gfQx7Hqtr+i+ugXj2F5i0D/EwGB3kcHgoNRXBsPXEL8a7ceu1wlojwkwpO+CPOt+goEXqFzmM4PlDpBezg+CR23eMQhvwa7Xl/EgmHZgZFzPELQX1d4DQKM1T+D0L9ChYoyMu0CWft8cvgNTr9B9PHpBIIKRcSuDz1KgXpCbYzZD3XwAGPx+iwnoZWCI28gQsDBhPViv2ku4XuE/uO31fX09aD6YpfgueB5EPUPyGribU1aHzcZpb9pKTf2ZQDpyG0PkjMxlDHyPGRiylsL1Zi9hiJ2CS2/uIgY/wR1szozzk35PKfo338RgRSTQJpje0lkM6e+EO3H4V91sE5gOuwpMPRXTgSyhiGlwvUVPdjIwZLfhCiuhaD5Gxi3yek1gZwj9+/747nNQmjRnEG1gYMgRvazHWIs/nIkEo3pH9Y7qHcp6u2rI1NpaythTRabe9mJGhr4KsrR2FgL7VgwcHaR3rqrb8hgYAOa6sJxV926gAAAAAElFTkSuQmCC';

                // Adiciona a logo
                doc.addImage(logoBase64, 'PNG', 10, 10, 30, 30);

                doc.setFontSize(16);
                doc.text(`Relatório Financeiro - ${moment(formValues.data_in).format('DD/MM/YYYY')} até ${moment(formValues.data_fn).format('DD/MM/YYYY')}`, 45, 25);

                const tabela = relatorios.sort((a, b) => new Date(a.horario) - new Date(b.horario)).map((item, index) => {
                    total += parseInt(item.valor);
                    return [
                        index + 1,
                        this.formatarNome(item.cliente_nome),
                        this.formatarCPF(item.cliente_cpf),
                        `R$ ${parseInt(item.valor).toFixed(2)}`,
                        'Pago',
                        moment(item.horario).format('DD/MM/YYYY [às] HH:mm:ss'),
                        item.estado,
                        item.cidade,
                        item.cep,
                        item.endereco
                    ];
                });

                autoTable(doc, {
                    startY: 50,
                    head: [["#", "Nome", "CPF", "Valor", "Status", "Horário do pagamento", "Estado", "Cidade", "CEP", "Endereço"]],
                    body: tabela,
                    theme: "grid",
                    tableWidth: 'auto',
                    styles: {
                        fontSize: 10,
                    },
                    margin: { 
                        left: 10, 
                        right: 10 
                    }
                });

                const precoFormatado = new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(total);

                // Exibir total
                doc.setFontSize(12);
                doc.text(`Total Geral: ${precoFormatado}`, 14, doc.lastAutoTable.finalY + 10);
                
                if (this.platform == 'desktop') {
                    doc.output('dataurlnewwindow');
                } else {
                    doc.save(`Relatório-${formValues.data_in}-${formValues.data_fn}.pdf`);
                }
            } 
            catch(e) 
            {
                Swal.fire(
                    'Ocorreu um erro',
                    e.message,
                    'warning'
                );
            }
        },
        formatarCPF(cpf) {
            return cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        },
        formatarNome(nome) {
            return nome.toLowerCase().split(' ').map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1)).join(' ');
        }
    },
    components: {
        Navbar,
        Loading
    },
    watch: {
        clients(clientes) {
            clientes.forEach((item) => {

                if (item.ativo == 'sim') {
                    this.active_clients += 1;
                    this.revenues += parseInt(item.mensalidade);
                }
            });
        },
        status_da_cobranca(value) {
            this.total_outstanding.amount = 0;
            this.total_outstanding.clients = 0;
            
            if (value == 'Atrasado') {
                for (const item of this.clients) {
                    if (item.ativo == 'sim' && item.status_da_cobranca == 'Atrasado') {
                        let mensalidade = parseFloat(item.mensalidade);
                        let x = this.diffTwoDates(item.data_da_cobranca);

                        if (x >= 1) {
                            mensalidade *= x;
                        }

                        this.total_outstanding.clients += 1;
                        this.total_outstanding.amount += mensalidade;
                    }
                }
            }
        }
    },
    computed: {
        filteredListClients() {
            return this.clients.filter((item) => {
                return (item.ativo.includes(this.active) && item.status_da_cobranca.includes(this.status_da_cobranca)) && this.removeAccents(item.nome).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim());
            });
        }
    },
    filters: {
        formatDate(date) {
            return moment(date).tz('America/Recife').format('DD/MM/YYYY');
        },
        formatCoin(n, c, d, t, s, i, j) {
            c = isNaN(c = Math.abs(c)) ? 2 : c, d = d == undefined ? "," : d, t = t == undefined ? "." : t, s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
		}
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.platform = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
        });
    },
    created() {
        this.listClients();
    }
}
</script>